import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-paragraph',
	templateUrl:'./ParagraphPluginCompPage.html',
	styles: [],
	styleUrls:['./ParagraphPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class ParagraphPluginCompPage
{
	mdContent_1086 = `\`\`\`java
import com.jwebmp.core.base.html.Paragraph;
\`\`\``;
	mdContent_1087 = `\`\`\`java
Paragraph()
\`\`\``;
	mdContent_1088 = `\`\`\`java
Paragraph(String text)
\`\`\``;
	mdContent_1089 = `\`\`\`java
Paragraph&lt;?&gt; p = new Paragraph&lt;&gt;();
p.setText("This is centred text.");
p.setTextAlign("center");
\`\`\``;
}
